import React from 'react';
import { assets } from '../../../../assets';
import NotificationBadge from './notification-badge';
import styled from 'styled-components';

const Container = styled.div.attrs(() => ({}))<{ small: boolean }>`
  position: relative;
  background-color: var(--primary-text-color);
  padding: ${(props) => (props.small ? '6px' : '8px')};
  border-radius: 100px;
  margin-left: ${(props) => (props.small ? '0px' : '40px')};
`;

const Image = styled.img.attrs(() => ({}))<{ small: boolean }>`
  width: ${(props) => (props.small ? '28px' : '32px')};
  height: ${(props) => (props.small ? '28px' : '32px')};
  object-fit: contain;
`;

const ProfileCircle = (props: {
  isActive?: boolean;
  onClick?: () => void;
  small?: boolean;
}): JSX.Element => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    if (props.onClick) {
      event.stopPropagation();
      props.onClick();
    }
  };

  return (
    <Container onClick={handleClick} small={!!props.small}>
      <Image
        small={!!props.small}
        src={props.isActive ? assets.icons.menu_profile_active : assets.icons.menu_profile}
        width={props.small ? 40 : 48}
        alt="profile"
      />
      <NotificationBadge />
    </Container>
  );
};

export default ProfileCircle;
